export type RectTuple = [number, number, number, number];
export type CircleTuple = [number, number, number];

export type ElectionDetails = {
  year: number;
  legalName: string;
  state: string;
  partyName: string;
  campaignCnpj: string;
  dataProtectionContact: string;
  dataProtectionOfficer: string;
};

export type Campaign = {
  slug: string;
  status: "draft" | "ready";
  assetsVerified: boolean;
  candidate: string;
  shortName: string;
  number: string;
  office: string;
  party: string;
  slogan: string;
  supportingText: string;
  shareText: string;
  election?: ElectionDetails;
  assets: {
    portrait: string;
    storyFrame: string;
    avatarFrame: string;
  };
  frameSources?: Partial<Record<"story" | "avatar", string>>;
  theme: {
    deep: string;
    surface: string;
    surfaceRaised: string;
    action: string;
    accent: string;
    success: string;
    ink: string;
    muted: string;
  };
  layouts: {
    story: { width: number; height: number; photoRect: RectTuple };
    avatar: { width: number; height: number; photoRect: RectTuple; clipCircle: CircleTuple; clipPhoto?: boolean };
  };
  seo: { title: string; description: string };
  deploy: { host: string; stack: string; image: string; router: string; replicas: number };
};

declare const __CAMPAIGN__: Campaign;

export const campaign = __CAMPAIGN__;
export const campaignAsset = (relativePath: string) => `/campaign/${relativePath}`;
